import { createAuthClient } from "better-auth/react";
import { oneTapClient } from "better-auth/client/plugins";

const baseURL = 'https://api.dbdesign.io/';
// const baseURL = 'http://localhost:3003/';

// Public Google OAuth 2.0 Web client ID (exposed in the bundle by design).
// const GOOGLE_CLIENT_ID = '177139694258-n52uj7lqs396kcb6h5tr0mv5rhej88ep.apps.googleusercontent.com';
const GOOGLE_CLIENT_ID = '177139694258-c738ovm5i8a08b7820c5jbv4jlkr3ueb.apps.googleusercontent.com';

export const authClient = createAuthClient({
    baseURL,
    plugins: [
        oneTapClient({
            clientId: GOOGLE_CLIENT_ID,
            autoSelect: false,
            cancelOnTapOutside: true,
            // 'use' → neutral "Continue with Google" wording, correct for both
            // new (sign-up) and returning (sign-in) users on the combined auth page.
            context: 'use',
            // maxAttempts:0 disables the plugin's re-prompt ladder. Its retry logic
            // predates FedCM: it treats a closed prompt as retryable unless the
            // dismissal reason is 'credential_returned'/'cancel_called'. Under FedCM a
            // click-outside no longer reports the legacy 'tap_outside' skip reason, so
            // it falls through to the retry branch and re-opens the prompt on a
            // 1s/2s/4s/8s/16s backoff — dismiss, it returns, five times over.
            // Google applies its own cooldown after a dismissal, so we want zero
            // client-side retries. (baseDelay is unused once maxAttempts is 0.)
            promptOptions: { maxAttempts: 0 },
        }),
    ],
});

// OAuth providers (and Google One Tap) redirect back to this URL after sign-in.
// Carry the invitation token (when the user started from /login?invite=<token>)
// so they land on the accept page instead of '/', which would drop the invite.
export function oauthCallbackURL() {
    const { origin, search } = window.location;
    const inviteToken = new URLSearchParams(search).get('invite');
    return inviteToken ? `${origin}/invite/${inviteToken}/accept` : origin;
}
